// 曝光 模块
const Group = () => import('@/views/exposure/Group')
const Detail = () => import('@/views/exposure/Detail')
const DetailPromotion = () => import('@/views/exposure/DetailPromotion')
const GroupPrice = () => import('@/views/exposure/GroupPrice')
const Intention = () => import('@/views/exposure/Intention')
const IntentionPromotion = () => import('@/views/exposure/IntentionPromotion')
const Order = () => import('@/views/exposure/Order')
const PCdetail = () => import('@/views/exposure/Pc-detail')
const Share = () => import('@/views/exposure/Share')
const NoticeFile = () => import('@/views/exposure/NoticeFiles')

export default [
	{
		path: '/exposure',
		redirect: '/exposure/group'
	},
  {
    path: '/exposure/group',
    component: Group,
    meta: {
      title: '跟团游'
    }
  },
  {
    path: '/exposure/detail',
    component: Detail,
    meta: {
      title: '产品详情'
    }
  },
  // 活动产品详情
  {
    path: '/exposure/pdetail',
    component: DetailPromotion,
    meta: {
      title: '产品详情'
    }
  },
  {
    path: '/exposure/groupprice',
    component: GroupPrice,
    meta: {
      title: '团期价格'
    }
  },
  {
    path: '/exposure/intention',
    component: Intention,
    meta: {
      title: '意向留位'
    }
  },
  // 活动下单
  {
    path: '/exposure/pintention',
    component: IntentionPromotion,
    meta: {
      title: '活动下单'
    }
  },
  {
    path: '/exposure/order',
    component: Order,
    meta: {
      title: '意向下单成功'
    }
  },
  {
    path: '/exposure/pcdetail',
    component: PCdetail,
    meta: {
      title: '阿联酋之行'
    }
  },
  {
    path: '/exposure/share',
    component: Share,
    meta: {
			title: '我的分享'
		}
  },
  {
    path: '/exposure/noticefile',
    component: NoticeFile,
    meta: {
      title: '出团通知书'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/exposure.js